export default __webpack_public_path__ + "assembly10a8f475.png";